import type { SVGProps } from "react";
import * as React from "react";

const SvgFilm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 2a1 1 0 0 0-2 0zM6 22a1 1 0 1 0 2 0zM18 2a1 1 0 1 0-2 0zm-2 20a1 1 0 1 0 2 0zM2 11a1 1 0 1 0 0 2zm20 2a1 1 0 1 0 0-2zM2 6a1 1 0 0 0 0 2zm5 2a1 1 0 0 0 0-2zm-5 8a1 1 0 1 0 0 2zm5 2a1 1 0 1 0 0-2zm10-2a1 1 0 1 0 0 2zm5 2a1 1 0 1 0 0-2zM17 6a1 1 0 1 0 0 2zm5 2a1 1 0 1 0 0-2zM4.18 3h15.64V1H4.18zm15.64 0c.652 0 1.18.528 1.18 1.18h2A3.18 3.18 0 0 0 19.82 1zM21 4.18v15.64h2V4.18zm0 15.64A1.18 1.18 0 0 1 19.82 21v2A3.18 3.18 0 0 0 23 19.82zM19.82 21H4.18v2h15.64zM4.18 21A1.18 1.18 0 0 1 3 19.82H1A3.18 3.18 0 0 0 4.18 23zM3 19.82V4.18H1v15.64zM3 4.18C3 3.528 3.528 3 4.18 3V1A3.18 3.18 0 0 0 1 4.18zM6 2v20h2V2zm10 0v20h2V2zM2 13h20v-2H2zm0-5h5V6H2zm0 10h5v-2H2zm15 0h5v-2h-5zm0-10h5V6h-5z"
    />
  </svg>
);
export default SvgFilm;
